import { TextField } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Theme, makeStyles } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { Card } from "@material-ui/core";
import { CardContent } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import React from "react";
import MesfModal from "../../../../../components/modals/modal.mesf";
import { Log } from "../../models/Log";

const useStyles = makeStyles((theme: Theme) => ({
	title: {
		fontSize: 15,
	},
	messageTitle: {
		marginBottom: 5,
		fontSize: 12,
		color: "#0000008A",
	},
}));

type Props = {
	show: boolean;
	onHide: (show: boolean) => void;
	selectedLog: Log | undefined;
};

const formatTime = (nowTime: any) => {
	if (nowTime == undefined) return;
	return nowTime.toLocaleDateString() + " " + nowTime.toLocaleTimeString();
};

export const ModalLogSelected = ({ show, onHide, selectedLog }: Props) => {
	const classes = useStyles();
	return (
		<Grid container justifyContent="center" alignItems="center">
			<MesfModal
				title="LOG DETAILS"
				open={show}
				handleClose={() => onHide(false)}
				maxWidth="md"
				id="log-details-modal"
			>
				<MesfModal.Content style={{ padding: "15px 30px" }}>
					<Grid container spacing={1} alignItems="flex-start">
						<Grid
							item
							md={6}
							xs={12}
							style={{ paddingRight: 20, paddingLeft: 5 }}
						>
							<TextField
								// disabled
								variant="standard"
								// variant="outline"
								fullWidth
								margin="dense"
								label="User"
								defaultValue={selectedLog?.User}
								InputProps={{
									readOnly: true,
								}}
							/>
						</Grid>
						<Grid
							item
							md={6}
							xs={12}
							style={{ paddingRight: 20, paddingLeft: 5 }}
						>
							<TextField
								// disabled
								variant="standard"
								// variant="outline"
								fullWidth
								margin="dense"
								label="Time"
								defaultValue={formatTime(selectedLog?.Timestamp)}
								InputProps={{
									readOnly: true,
								}}
							/>
						</Grid>
						<Grid
							item
							md={6}
							xs={12}
							style={{ paddingRight: 20, paddingLeft: 5 }}
						>
							<TextField
								// disabled
								variant="standard"
								// variant="outline"
								fullWidth
								margin="dense"
								label="Source"
								defaultValue={selectedLog?.Source}
								InputProps={{
									readOnly: true,
								}}
							/>
						</Grid>
						<Grid
							item
							md={6}
							xs={12}
							style={{ paddingRight: 20, paddingLeft: 5 }}
						>
							<TextField
								// disabled
								variant="standard"
								// variant="outline"
								fullWidth
								margin="dense"
								label="Type"
								defaultValue={selectedLog?.LogTypeCode}
								InputProps={{
									readOnly: true,
								}}
							/>
						</Grid>
						<Grid
							item
							md={12}
							xs={12}
							style={{ paddingRight: 20, paddingLeft: 5, marginBottom: 20 }}
						>
							<Card variant="outlined" style={{ backgroundColor: "#E9F2F8" }}>
								<CardContent>
									<Typography className={classes.messageTitle}>
										Message:
									</Typography>
									<Typography style={{ fontSize: 17 }}>
										{selectedLog?.Message}
									</Typography>
								</CardContent>
							</Card>
						</Grid>
					</Grid>
				</MesfModal.Content>
				<MesfModal.Actions style={{ padding: "20px 30px 30px" }}>
					<Grid container spacing={2} justifyContent="flex-end">
						<Grid item md={3} xs={12} style={{ margin: 0 }}>
							<Button
								fullWidth
								variant="contained"
								color="default"
								onClick={() => onHide(true)}
							>
								Close
							</Button>
						</Grid>
					</Grid>
				</MesfModal.Actions>
			</MesfModal>
		</Grid>
	);
};
